import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DataTableContext from '../../../../../context/DataTableContext';

export const ReadOnlyData = (props) => {
  const tableContext = useContext(DataTableContext);
  const { customProps, data, dataKey, icon, isHeader } = props;

  const onClick = () => {
    if (!tableContext.onRowClickCondition || tableContext.onRowClickCondition(data)) {
      return tableContext.onRowClick ? tableContext.onRowClick(data.id) : () => { };
    }
  };

  const TableHeader = () => {
    const thProps = customProps?.th || {};
    return (
      <th {...thProps}>
        {data[dataKey]}
      </th>
    );
  };

  const TableData = () => {
    let Icon = null;
    if (icon) {
      Icon = icon.condition ? icon.condition.values[data[icon.condition.column]] : icon;
    }

    const tdProps = customProps?.td || {};
    return (
      <td
        onClick={onClick}
        {...tdProps}>
        {
          Icon &&
          <Icon style={{ marginRight: '5px', width: '20px', height: '20px' }} />}
        {data[dataKey]
        }
      </td>
    );
  };

  return isHeader ? <TableHeader /> : <TableData />;
};

ReadOnlyData.defaultProps = {
  isHeader: false
};

ReadOnlyData.propTypes = {
  customProps: PropTypes.object,
  icon: PropTypes.object,
  data: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired
};